import { render } from "./questionForm.vue?vue&type=template&id=01aa33e1&scoped=true"
import script from "./questionForm.vue?vue&type=script&lang=js"
export * from "./questionForm.vue?vue&type=script&lang=js"

import "./questionForm.vue?vue&type=style&index=0&id=01aa33e1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01aa33e1"]])

export default __exports__